import { TextCell } from "@/components/2/text-cell/text-cell";

type AircallPhoneCellProps = {
  phoneNumber: string | null;
  onUpdate?: (value: string) => void;
};

export const AircallPhoneCell = ({ phoneNumber, onUpdate }: AircallPhoneCellProps) => {
  return (
    <TextCell
      value={phoneNumber}
      onSave={onUpdate ? value => onUpdate(value) : undefined}
      placeholder="Phone number (e.g., +33 1 23 45 67 89)"
    />
  );
};
